import AddResource from '../modals/AddResource';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import ResourcesCards from './ResourcesCards';
import {useState} from "react";
import {SearchByFilters} from "../../../reduxToolkit/Search/SearchApi";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ResourcesTab = ({
      view,
      option,
      setBodyForExport,
      selectedList,
      setSelectedList,
      searchElement,
      setSearchElement,
      isAllChecked,
      setIsAllChecked,
      modified,
      setModified,
      setSearch,
      simpleSearch,
      setSimpleSearch,
    addResourceShow,
    setAddResourceShow
}) => {
    const [currImg, setCurrImg] = useState(null);
    const [openViewer, setOpenViewer] = useState(false);
    // Resource opened from a card, it is null while the modal is used to create
    const [resourceSelected, setResourceSelected] = useState(null);
    const [resourceDisabled, setResourceDisabled] = useState(false);
    const imageArray = (SearchByFilters?.content || []).map((item) => ({
        src: `data:image/png;base64,${item?.image}`,
    }));

    /**
     * Opens the resource modal from a card.
     *
     * @param {object} item - The resource of the selected card.
     * @param {boolean} disabled - True when the user can only inspect the resource.
     */
    const handleOpenResource = (item, disabled) => {
        setResourceSelected(item);
        setResourceDisabled(disabled);
        setAddResourceShow(true);
    };

    /**
     * Opens the resource modal in create mode, with no resource preselected.
     */
    const handleCreateResource = () => {
        setResourceSelected(null);
        setResourceDisabled(false);
        setAddResourceShow(true);
    };

    // Closes the modal and clears the selected resource so it opens on the create action again.
    const handleCloseResource = () => {
        setAddResourceShow(false);
        setResourceSelected(null);
        setResourceDisabled(false);
    };

    return (
        <>
            <ResourcesCards
                view={view}
                option={option}
                setBodyForExport={setBodyForExport}
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                modified={modified}
                setModified={setModified}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                setOpenViewer={setOpenViewer}
                setCurrImg={setCurrImg}
                onOpenResource={handleOpenResource}
                onCreateResource={handleCreateResource}
            />

            <AddResource
                open={addResourceShow}
                onClose={handleCloseResource}
                onUpdated={() => setModified(true)}
                resource={resourceSelected}
                disabled={resourceDisabled}
            />
            <Lightbox
                open={openViewer}
                close={() => setOpenViewer(false)}
                slides={imageArray}
                index={imageArray.findIndex((item) => item.src === currImg)}
            />
        </>
    );
};
export default ResourcesTab;
